import { useMemo } from 'react'

export const useHumanReadableDuration = (
  /**
   * unit: seconds
   */
  duration: number,
) => {
  return useMemo(() => {
    const minutes = Math.floor(duration / 60)
    const seconds = Math.floor(duration % 60)

    const paddedMinutes = minutes.toString().padStart(2, '0')
    const paddedSeconds = seconds.toString().padStart(2, '0')

    return `${paddedMinutes}:${paddedSeconds}`
  }, [duration])
}
